import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import Modal from 'react-modal';
import { enableScroll, disableScroll } from '../../shared/scroll';
import styles from './Modal.css';

const cx = classnames.bind(styles);

function CustomModal({isOpen, onCloseModal, children, className, inModal, overlayClassName}) {
    const classes = cx({
        modalContent: true,
        [className]: Boolean(className)
    });

    useEffect(() => {
        if (isOpen && !inModal) {
            disableScroll();
        };

        return () => {
            if (!inModal) {
                enableScroll();
            }
        };
    }, [isOpen]);

    const handleClose = () => {
        onCloseModal?.();
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={handleClose}
            ariaHideApp={false}
            overlayClassName={cx('overlayModal', overlayClassName)}
            className={classes}
            closeTimeoutMS={200}
        >
            {children}
        </Modal>
    );
}

CustomModal.defaultProps = {
    isOpen: false,
    inModal: false,
    onCloseModal: null,
    overlayClassName: ''
};

CustomModal.propTypes = {
    isOpen: PropTypes.bool,
    inModal: PropTypes.bool,
    onCloseModal: PropTypes.func,
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    overlayClassName: PropTypes.string
};

export default CustomModal;
